import { BaseEntity, BaseSearchForm } from 'entities'
import { TaskMaster } from './task_master'
import { User } from './user'

export type TaskMasterSetKind = 'MATERIAL'

export const taskMasterSetKindJa: { [key: string]: string } = { MATERIAL: '資材' }

export type TaskMasterSet = BaseEntity & {
    title?: string
    kind?: TaskMasterSetKind
    taskMasters?: TaskMaster[]
    user?: User
    data?: string
}

export type TaskMasterSetForm = TaskMasterSet

export type TaskMasterSetSearchForm = TaskMasterSet & BaseSearchForm
